import React, { createContext, useContext, useState, useEffect } from 'react';

const StockContext = createContext();

export const useStock = () => {
  const context = useContext(StockContext);
  if (!context) {
    throw new Error('useStock must be used within a StockProvider');
  }
  return context;
};

export const StockProvider = ({ children }) => {
  const [currentStock, setCurrentStock] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Charger le stock actif depuis localStorage au démarrage
  useEffect(() => {
    const savedStock = localStorage.getItem('currentStock');
    if (savedStock) {
      try {
        setCurrentStock(JSON.parse(savedStock));
      } catch (error) {
        console.error('Erreur lors du chargement du stock:', error);
      }
    }
  }, []);

  const changeStock = (newStock) => {
    setCurrentStock(newStock);
    localStorage.setItem('currentStock', JSON.stringify(newStock));
    // Déclencher un rafraîchissement global
    setRefreshTrigger(prev => prev + 1);
  };

  const triggerRefresh = () => {
    // Déclencher un rafraîchissement global (pour le dashboard, produits, fournisseurs, commandes, etc.)
    setRefreshTrigger(prev => prev + 1);
  };

  const value = {
    currentStock,
    changeStock,
    refreshTrigger,
    triggerRefresh
  };

  return (
    <StockContext.Provider value={value}>
      {children}
    </StockContext.Provider>
  );
};
